"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCookbookMutationOptions = exports.deleteCookbookMutation = void 0;
const client_1 = require("@apollo/client");
const updateQuery_1 = require("../../../utils/updateQuery");
const browseCookbook_1 = require("../queries/browseCookbook");
exports.deleteCookbookMutation = client_1.gql `
  mutation DeleteCookbook($id: String!) {
    deleteCookbook(id: $id) {
      __typename
      ok
    }
  }
`;
exports.deleteCookbookMutationOptions = (variables) => ({
    variables,
    optimisticResponse: {
        __typename: "Mutation",
        deleteCookbook: {
            __typename: "OkResponse",
            ok: true,
        },
    },
    update: store => {
        updateQuery_1.updateQuery(store, browseCookbook_1.cookbooksQuery, x => {
            x.cookbooks = x.cookbooks.filter(y => y.id !== variables.id);
        });
    },
});
//# sourceMappingURL=deleteCookbook.js.map